module.exports = __webpack_public_path__ + "static/media/WndEITS_services.cbbc6884.jpg";